module.exports = __webpack_public_path__ + "img/categories_memoire_mobile_all@2x.43c669a.jpg";